import { OpenIdConfiguration } from 'angular-auth-oidc-client';
import { settings } from '../globals/settings';

export const openIdConfiguration: OpenIdConfiguration = {
	authority: settings.endpoints.authRoot,
	redirectUrl: window.location.origin + window.location.pathname,
	clientId: 'assessment.ui',
	scope: 'openid profile offline_access game.play',
	responseType: 'code',
	silentRenew: true,
	useRefreshToken: true,
	renewTimeBeforeTokenExpiresInSeconds: 30,
	secureRoutes: [
		settings.endpoints.authRoot,
		settings.endpoints.gameApiRoot,
	],
	configId: 'assessment.ui',
	maxIdTokenIatOffsetAllowedInSeconds: 600,
};
